import React from 'react';
import { Link } from 'react-router-dom';

export const Privacy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white shadow rounded-lg p-8">
          <div className="mb-8">
            <Link to="/" className="text-blue-600 hover:text-blue-500">
              ← Back to Home
            </Link>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
          
          <div className="prose max-w-none">
            <p className="mb-4">Last updated: January 9, 2025</p>

            <h2 className="text-xl font-semibold mt-6 mb-4">1. Introduction</h2>
            <p>
              SayCard ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our voice-to-contact service.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-4">2. Information We Collect</h2>
            <p>We collect information that you provide directly to us, including:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Account information (name, email, password)</li>
              <li>Voice recordings during contact creation</li>
              <li>Contact information you choose to save</li>
              <li>Profile preferences and settings</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-4">3. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Provide and maintain our service</li>
              <li>Process voice recordings into contact information</li>
              <li>Improve our voice recognition accuracy</li>
              <li>Communicate with you about our service</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-4">4. Data Storage and Security</h2>
            <p>
              Voice recordings are processed in real-time and are not stored on our servers. Contact information is stored securely and encrypted. We implement appropriate technical and organizational measures to protect your data.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-4">5. GDPR Compliance</h2>
            <p>For users in the European Union, we:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Process data lawfully and transparently</li>
              <li>Collect data only for specified purposes</li>
              <li>Minimize data collection to what's necessary</li>
              <li>Keep data accurate and up-to-date</li>
              <li>Store data only as long as necessary</li>
              <li>Ensure appropriate security measures</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-4">6. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to data processing</li>
              <li>Data portability</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-4">7. Contact Us</h2>
            <p>
              For any privacy-related questions or concerns, please contact us at privacy@saycard.app
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
